import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { Send } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AanmeldModal({ open, onOpenChange, groep, description }) {
  const [form, setForm] = useState({ naam: "", email: "", telefoon: "", bericht: "" });
  const [werkgroep, setWerkgroep] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  async function submit(e) {
    e.preventDefault();
    if (!form.naam || !form.email) {
      toast.error("Vul je naam en e-mailadres in.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/aanmelding`, { ...form, groep, werkgroep });
      toast.success(`Aanmelding als "${groep}" ontvangen! We nemen contact op.`);
      setForm({ naam: "", email: "", telefoon: "", bericht: "" });
      setWerkgroep(false);
      onOpenChange(false);
    } catch (err) {
      toast.error("Er ging iets mis. Probeer het opnieuw.");
    } finally {
      setLoading(false);
    }
  }

  const inputClass =
    "w-full px-4 py-3 rounded-lg bg-[#FAF7F2] border border-[#2D6A4F]/20 text-[#1A2E22] placeholder:text-[#1A2E22]/35 text-sm outline-none focus:border-[#74C69D] transition-colors";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-[#2D6A4F]/15 max-h-[90vh] overflow-y-auto" data-testid="aanmeld-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-[#1A2E22]">
            Aanmelden — {groep}
          </DialogTitle>
          <DialogDescription className="text-[#1A2E22]/65">{description}</DialogDescription>
        </DialogHeader>

        <form onSubmit={submit} className="flex flex-col gap-4 mt-2" data-testid="aanmeld-form">
          <div>
            <label className="block text-sm font-semibold text-[#1A2E22] mb-1.5">Je naam</label>
            <input
              name="naam"
              value={form.naam}
              onChange={handleChange}
              placeholder="Voornaam Achternaam"
              data-testid="aanmeld-input-naam"
              className={inputClass}
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#1A2E22] mb-1.5">E-mailadres</label>
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder="jij@voorbeeld.nl"
              data-testid="aanmeld-input-email"
              className={inputClass}
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#1A2E22] mb-1.5">
              Telefoonnummer <span className="font-normal text-[#1A2E22]/50">(optioneel)</span>
            </label>
            <input
              name="telefoon"
              type="tel"
              value={form.telefoon}
              onChange={handleChange}
              placeholder="06 12345678"
              data-testid="aanmeld-input-telefoon"
              className={inputClass}
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#1A2E22] mb-1.5">
              Opmerking <span className="font-normal text-[#1A2E22]/50">(optioneel)</span>
            </label>
            <textarea
              name="bericht"
              value={form.bericht}
              onChange={handleChange}
              placeholder="Bijv. waar je mee wilt helpen of welk thema je interesseert…"
              rows={3}
              data-testid="aanmeld-input-bericht"
              className={`${inputClass} resize-y`}
            />
          </div>

          <label className="flex items-start gap-3 rounded-lg bg-[#FAF7F2] border border-[#2D6A4F]/15 px-4 py-3 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={werkgroep}
              onChange={(e) => setWerkgroep(e.target.checked)}
              data-testid="aanmeld-werkgroep-checkbox"
              className="w-4 h-4 mt-0.5 accent-[#2D6A4F]"
            />
            <span className="text-sm text-[#1A2E22]">
              <strong>Ik wil meedoen in een werkgroep</strong>
              <span className="block text-[#1A2E22]/60">financiën, ontwerp of communicatie</span>
            </span>
          </label>

          <button
            type="submit"
            disabled={loading}
            data-testid="aanmeld-submit"
            className="mt-1 inline-flex items-center justify-center gap-2 w-full font-bold text-sm px-7 py-3.5 rounded-full bg-[#2D6A4F] text-white hover:bg-[#357c5d] transition-colors disabled:opacity-70"
          >
            {loading ? "Bezig met versturen…" : "Aanmelden"}
            {!loading && <Send size={16} />}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
